import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface OrderData {
    alrimtalk_history_idx: number;
    msg_key: string;
    order_idx: number;
    order_mobile: string;
    order_status: number;
    order_status_text: string;
    service_type: string;
    report_code: string;
    report_code_text: string;
    send_time: string;
    reg_date: string;
    order_name: string;
}

interface GetMemberResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: OrderData[];
}

export const useGetOrderChat = ({ order_idx }: { order_idx: string }): UseQueryResult<GetMemberResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetMemberResponse, Error>({
        queryKey: ["useGetOrderChat", order_idx],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_chat.replace(":order_idx", order_idx)}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
